module.exports = __webpack_public_path__ + "static/medikane-logo-1d7034d1b58b3c66333067bb7e7cf97a.svg";